'use strict';

var capAddressConfiguration = require('./function');
const callWebService = require('./serverActions/callWebService');
const isAutoFillUtil = require('./../utils/isautofill');
const autocompleteUtil = require('./../utils/autocomplete');
var serviceDownZipCode = false;
var serviceDownZipCodeGB = false;
var serviceDownCity = false;
var capencyFields = [];

/**
* Empties the values of specified input fields and disables the county input field if it exists.
*
* @param {Object} config - Configuration object containing the IDs of the input fields to be emptied.
* @param {string} config.zipID - The ID of the ZIP code input field.
* @param {string} config.cityID - The ID of the city input field.
*/
function emptyInput(config) {
    var $county = $('input[name$="_stateCode"]');

    $('#' + config.zipID).val('');
    $('#' + config.cityID).val('');

    setTimeout(function () {
        if ($county.length > 0) {
            $county.val('').attr('disabled', true);
        }
    }, 200);
}

/**
 * reset Verify Address Modal Form
 */
function resetVerifyAddressModalForm() {
    $('#verifyAddresseModel input').prop('checked', false);
}

function storeInitialFieldValues() {
    capencyFields.forEach(function (field) {
        if (field.data('initialValue') === undefined) {
            field.data('initialValue', field.val());
        }
    });
}

/**
* Configures the address form fields based on the provided form ID and country-specific settings.
*
* This function retrieves the configuration for the specified form ID and sets up various event listeners
* and handlers for address form fields. It handles country-specific logic, such as enabling/disabling fields
* and making AJAX calls to fetch address suggestions based on postal codes or street names.
*
* @async
* @param {string} formID - The ID of the form to configure.
* @returns {Promise<void>} - A promise that resolves when the configuration is complete.
*/
async function setConfigToCapAddress(formID) {
    // get config from de request Ajav for the currentForm
    var config = capAddressConfiguration.getConfig(formID);
    var hasStepSearchAddressByPostalCode = 0;
    if (config) {
        const $prefix = '#' + formID + ' ';
        const $address1Selector = $prefix + '#' + config.addressID_1;
        const $address2Selector = $prefix + '#' + config.addressID_2;
        const $citySelector = $prefix + '#' + config.cityID;
        const $zipCodeSelector = $prefix + '#' + config.zipID;
        const $countrySelector = $prefix + '#' + config.customCountryID;
        const $dropDownCountrySelector = $prefix + '#' + config.dropdownCountryID;
        let $address1 = $($address1Selector);
        let $address2 = $($address2Selector);
        let $city = $($citySelector);
        let $zipCode = $($zipCodeSelector);
        let $country = $($countrySelector);
        let $dropdownCountry = $($dropDownCountrySelector);
        capencyFields.push($address1, $address2, $city, $zipCode, $country);
        storeInitialFieldValues();

        // events keyup for ZIP Code
        var debounceZipCode;
        $($zipCodeSelector).data('previousValue', $($zipCodeSelector).val());
        $($zipCodeSelector).on('keyup', function (e) {
            if (isAutoFillUtil.isAutofill(e)) {
                return false;
            }

            var value = $(this).val();
            removeAddressClass();

            if (value === '') {
                handleEmptyInput($(this), debounceZipCode, config);

                return false;
            }

            clearTimeout(debounceZipCode);

            if (serviceDownZipCode === false) {
                const $this = $(this);
                debounceZipCode = setTimeout(function () {
                    if (value !== '' && checkInputChanged($this)) {
                        capAddressConfiguration.callProcessAddressFlow(config);
                    }
                }, 300);
            } else {
                if ($(this).autocomplete('instance')){
                    $(this).autocomplete('option', { source: [] });
                }
                window.capency.isServiceUp === false;
            }

            if (window.capency.isServiceUp === false) {
                serviceDownZipCode = true;
                serviceDownCity = true;
            } else {
                serviceDownZipCode = false;
                serviceDownCity = false;
            }
        });

        $($zipCodeSelector).on('blur', function () {
            closeAutocomplete($zipCode);
        });
        var debounceAddress;
        $dropdownCountry.parent('.dropdown').find('.dropdown-item').on('click', function () {
            clearTimeout(debounceAddress);
            if (window.capency.isServiceUp === true) {
                debounceAddress = setTimeout(function () {
                    capAddressConfiguration.callProcessSearchStreet(config);
                    $address1.toggleClass('clickedOut', true);
                }, 300);
            } else {
                serviceDownZipCode = true;
                serviceDownCity = true;
                if (hasStepSearchAddressByPostalCode === 1) {
                    serviceDownZipCodeGB = true;
                }
            }
        });

        $($address1Selector).data('previousValue', $($address1Selector).val());
        // events keyup for addressID_1
        $($address1Selector).on('keyup', function (event) {
            if (isAutoFillUtil.isAutofill(event)) {
                return false;
            }

            let $this = $(this);
            var value = $this.val();
            removeAddressClass();
            $this.removeAttr('data-selected-address');

            if (value === '') {
                handleEmptyInput($(this), debounceAddress, config);

                return false;
            }

            // call ajax for get suggestions
            if ($this.hasClass('has-proposition-false') === false) {
                clearTimeout(debounceAddress);

                if (window.capency.isServiceUp === true) {
                    debounceAddress = setTimeout(function () {
                        if (value !== '' && checkInputChanged($this)) {
                            capAddressConfiguration.callProcessSearchStreet(config);
                        }
                    }, 300);
                } else {
                    if ($(this).autocomplete('instance')){
                        $this.autocomplete('option', { source: [] });
                    }
                    serviceDownZipCode = true;
                    serviceDownCity = true;
                    if (hasStepSearchAddressByPostalCode === 1) {
                        serviceDownZipCodeGB = true;
                    }
                }
            } else {
                if ($(this).autocomplete('instance')){
                    $this.autocomplete('option', { source: [] });
                }
                return false;
            }

            resetVerifyAddressModalForm();
        });

        $($address2Selector).data('previousValue', $($address2Selector).val());
        // events keyup for addressID_2
        $($address2Selector).on('keyup', function (event) {
            if (isAutoFillUtil.isAutofill(event)) {
                return false;
            }

            var value = $(this).val();
            $address2.toggleClass('autocomplete-field-selected', false);

            if (value === '') {
                return false;
            }

            let address1Selected = $address1.hasClass('autocomplete-field-selected');
            let citySelected = $city.hasClass('autocomplete-field-selected');
            let zipCodeSelected = $zipCode.hasClass('autocomplete-field-selected');
            if (value && address1Selected && citySelected && zipCodeSelected) {
                let selectedAddressData = $address1.data('selectedAddress');
                if (!selectedAddressData) {
                    return;
                }
                // call ajax for get suggestions
                if ($(this).hasClass('has-proposition-false') === false) {
                    clearTimeout(debounceAddress);

                    if (window.capency.isServiceUp === true) {
                        const $this = $(this);
                        debounceAddress = setTimeout(function () {
                            if (value !== '' && checkInputChanged($this)) {
                                capAddressConfiguration.callProcessSearchBuilding(config, selectedAddressData);
                            }
                        }, 300);
                    } else {
                        if ($(this).autocomplete('instance')){
                            $(this).autocomplete('option', { source: [] });
                        }
                    }
                } else {
                    if ($(this).autocomplete('instance')){
                        $(this).autocomplete('option', { source: [] });
                    }
                    return false;
                }
            }
        });

        $($address1Selector).on('blur', function () {
            closeAutocomplete($(this));
        });

        $($address2Selector).on('blur', function () {
            closeAutocomplete($(this));
        });

        var debounceCity;
        $($citySelector).data('previousValue', $($citySelector).val());
        // events keyup keypress keydown for cityID
        $($citySelector).on('keyup', function (evt) {
            if (isAutoFillUtil.isAutofill(evt)) {
                return false;
            }

            var value = $(this).val();
            var TABKEY = 9;
            removeAddressClass()

            if (value === '' && evt.keyCode == TABKEY) {
                if (evt.preventDefault) {
                    evt.preventDefault();
                }
                return false;
            }

            if (value === '') {
                $zipCode.val('');

                if ($zipCode.val() !== '') {
                    if ($zipCode.autocomplete('instance')) {
                        $zipCode.autocomplete('option', { source: [] });
                    }
                }

                handleEmptyInput($(this), debounceCity, config);

                return false;
            }

            clearTimeout(debounceCity);
            // call ajax for get suggestions
            if (!serviceDownCity) {
                const $this = $(this);
                debounceCity = setTimeout(function () {
                    if (value !== '' && checkInputChanged($this)) {
                        capAddressConfiguration.callProcessAddressFlowByCity(config);
                    }
                }, 300);
            }
            else {
                if ($(this).autocomplete('instance')){
                    $(this).autocomplete('option', { source: [] });
                }
                window.capency.isServiceUp === false;
            }

            if (hasStepSearchAddressByPostalCode === 1) {
                if ($('#' + config.zipID).autocomplete('instance')){
                    $('#' + config.zipID).autocomplete('option', { source: [] });
                }
            }

            if (window.capency.isServiceUp === false) {
                serviceDownCity = true;
                serviceDownZipCode = true;
            } else {
                serviceDownCity = false;
                serviceDownZipCode = false;
            }
        });

        $($citySelector).on('blur', function () {
            closeAutocomplete($(this));
        });

        // set default country in shipping Form
        $('.shipping-form').find('.btn-add-new').on('click', function (e) {
            e.preventDefault();
            setTimeout(function () {
                $('select[name$=_country]', '.shipping-form').val('FR').change();

                var currentCountry = $('#currentCountry').val();

                if (currentCountry === 'FR') {
                    setTimeout(function () {
                        $('select[name$=_country]', '.shipping-form').val('FR').change();
                    }, 500);
                }

                $('.shipping-form').find('input[name$="_address1"]').attr('disabled', true);
                $('.shipping-form').find('input[name$="_address2"]').attr('disabled', true);
            }, 200);
        });

        $('.address-edit').find('input[name$="_address_address1"]').attr('disabled', false);
        $('.address-edit').find('input[name$="_address_address2"]').attr('disabled', false);

        return false;
    }
}

/**
 * Function to check if value of input has changed on keyup event
 *
 * @param {Object} $this - The jQuery object representing the input field.
 */
function checkInputChanged($this) {
    var value = $this.val();
    var previousValue = $this.data('previousValue');

    if (value !== previousValue) {
        $this.data('previousValue', value);
        return true;
    }

    return false;
}

/**
 * @param {Object} $this
 * @param {Object} debounce
 * @param {Object} config
 */
function handleEmptyInput($this, debounce, config) {
    $this.find('input').autocomplete();
    if ($this.autocomplete('instance')){
        $this.autocomplete('option', { source: [] });
    }

    clearTimeout(debounce);
    emptyInput(config);
}

/**
* Retrieves the ID of the form that contains the specified country input element.
*
* @param {string} inputCountryID - The ID of the country input element.
* @returns {string|undefined} The ID of the form containing the country input element, or undefined if the element is not found.
*/
function getFormID(inputCountryID) {
    var $inputCountry = $('#' + (inputCountryID));
    var formID = $inputCountry.closest('form').attr('id');
    if ($inputCountry.length === 0) {
        return;
    }
    return formID;
}

/**
 * @function loadState get stetes form json and load ui-autocomplete
*/
function loadState() {
    var capConstants = require('capencyBase/../../../config/states.json');
    var finalDatasource = null;
    finalDatasource = $.map(capConstants.default, function (item) {
        return {
            label: item.key,
            value: item.value
        };
    });

    // Load ui-autocomplete
    $('#state').autocomplete({
        source: finalDatasource
    });
}

/**
* Handles the dynamic addition of fields in a form based on the selected country.
* This function retrieves the configuration for the specified form ID, identifies the country input field,
* and sets up an event listener to trigger the addition of new fields when the country selection changes.
*
* @param {string} formID - The ID of the form to be processed.
*/
function handleMultipleCountryInForm(formID) {
    var config = capAddressConfiguration.getConfig(formID);
    if (config && config.hasOwnProperty('countryID')) {
        var countryInputId = config.countryID;
        if (countryInputId) {
            formID = getFormID(countryInputId);
            var $selectorCountry = $('#' + countryInputId);

            if ($selectorCountry.length) {
                $selectorCountry.change(function (e) {
                    e.preventDefault();
                    addNewFieldByCountry(String(formID), $(this).val());
                });

                $selectorCountry.trigger('change');
            }
        }
    }
}

/**
* Adds a new input field to the form based on the selected country.
*
* This function dynamically adds a state input field to the form when the selected country is the United States.
* If the selected country is not the United States, it removes the state input field if it exists.
*
* @param {string} formID - The ID of the form to which the new field will be added.
* @param {string} codeCountry - The country code used to determine which field to add.
*/
function addNewFieldByCountry(formID, codeCountry) {
    var config = capAddressConfiguration.getConfig(formID);
    if (config && config.hasOwnProperty('countryID')) {
        // get id country selector for the current form
        var countryInputId = config.countryID;
        if (formID && countryInputId) {
            var idCountry = countryInputId;
            var $selectorCountry = $('#' + idCountry);
            switch (String(codeCountry)) {
                case 'US':
                    var newInput = `<div class="col-6 cap-field-state">
                    <div class="form-group required">
                          <label class="form-control-label" for="city">
                              State
                          </label>
                          <input type="text" class="form-control" id="state" name="dwfrm_address_state" required="" aria-required="true" value="" maxlength="50" minlength="2" autocomplete="off">
                          <div class="invalid-feedback"></div>
                      </div>
                    </div>`;
                    if (!$selectorCountry.parents('.col-6').hasClass('cap-country')) {
                        $selectorCountry.parents('.col-6').addClass('cap-country');
                        $('.cap-country').after(newInput);
                        loadState();
                    }

                    break;
                default:
                    $('.cap-field-state').remove();
                    break;
            }
        }
    }
}

/**
* Removes the 'is-invalid' CSS class from address-related input fields.
* This function targets specific input fields for address line 1, city, and zip code,
* and removes the 'is-invalid' class to reset their validation state.
* @requires jQuery
*/
function removeAddressClass() {
    var $address1 = $('input[name$="_address1"]');
    var $address2 = $('input[name$="_address2"]');
    var $city = $('input[name$="_city"]');
    var $zipCode = $('input[name$="_postalCode"]');

    $address1.removeClass('is-invalid');
    $zipCode.removeClass('is-invalid');
    $city.removeClass('is-invalid');

    $('.banner-message').addClass('d-none');

    $address1.toggleClass('autocomplete-field-selected', false);
    $address2.toggleClass('autocomplete-field-selected', false);
    $city.toggleClass('autocomplete-field-selected', false);
    $zipCode.toggleClass('autocomplete-field-selected', false);
}

/**
* Disables browser autocomplete for all text input fields within a specified form.
*
* @param {string} formID - The ID of the form for which autocomplete should be disabled.
*                          If the form with the specified ID is not found and the ID is
*                          '"dwfrm_address"', it will attempt to use the form with the
*                          name '"dwfrm_address"'.
*/
function deleteAutoCompleteBrowser(formID) {
    var $formSelector = $("form[id='" + formID + "']");

    if ($formSelector.length === 0 && formID === '"dwfrm_address"') {
        $formSelector = '"dwfrm_address"';
    }

    if ($formSelector.length === 0) {
        $formSelector = $("form[name='" + formID + "']");
    }

    $formSelector.find('input[type=text]').each(function () {
        $(this).attr('autocomplete', $(this).attr('type') === 'email' ? 'off' : autocompleteUtil.getAutocompleteValue());
    });
}

/**
* Removes duplicate elements from an array.
*
* This function takes an array as input and returns a new array with all duplicate elements removed.
* It uses the `filter` method to ensure that each element appears only once in the returned array.
*
* @param {Array} arr - The array from which duplicates need to be removed.
* @returns {Array} A new array with duplicates removed.
*/
function removeDuplicates(arr) {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
}

/**
* Destroys the jQuery UI autocomplete widget for the given elements.
* If an array of elements is provided, it iterates through each element and destroys its autocomplete widget.
* If a single element is provided, it directly destroys its autocomplete widget.
*
* @param {jQuery|jQuery[]} $elements - A jQuery object or an array of jQuery objects representing the elements to destroy the autocomplete widget on.
*/
function destroyAutocomplete($elements) {
    if (Array.isArray($elements)) {
        $.each($elements, function (index, element) {
            let $element = $(element);
            if ($element.data('ui-autocomplete')) {
                $element.autocomplete('destroy');
            }
        });
    } else if ($elements.data('ui-autocomplete')) {
        $elements.autocomplete('destroy');
    }
}

/**
* Closes the autocomplete suggestions for the given jQuery elements.
*
* @param {jQuery|jQuery[]} $elements - A jQuery object or an array of jQuery objects representing the elements with autocomplete functionality.
*/
function closeAutocomplete($elements) {
    if (Array.isArray($elements)) {
        $.each($elements, function (index, element) {
            let $element = $(element);
            if ($element.data('ui-autocomplete')) {
                $element.autocomplete('close');
            }
        });
    } else if ($elements.data('ui-autocomplete')) {
        $elements.autocomplete('close');
    }
}

/**
* Event handler function that destroys the autocomplete functionality of a given element.
*
* @param {Event} event - The event object that triggered the handler.
* @param {Object} data - An object containing additional data for the event.
* @param {HTMLElement} data.element - The HTML element for which the autocomplete should be destroyed.
* @returns {void}
*/
$(document).on('autocomplete:destroy', function (event, data) {
    destroyAutocomplete(data.element);
});

module.exports = {
    // init cap address by Form
    initCapAddressByForms: (formIdListToInit = []) => {
        // get all configuration
        var listFormWithCapAddress = capAddressConfiguration.getIdForms();
        var formIDInBody = [];
        // set function for the current form in the page
        $('form').each(function () {
            var formID = (String($(this).attr('id')) === 'undefined' || typeof String($(this).attr('id')) === 'undefined') ? $(this).attr('name') : String($(this).attr('id'));
            if (formID && listFormWithCapAddress.includes(formID) && (formIdListToInit.length === 0 || formIdListToInit.includes(formID))) {
                formIDInBody.push(formID);
            }
        });

        var listFormsWithoutDuplicatesData = removeDuplicates(formIDInBody);
        $.each(listFormsWithoutDuplicatesData, function (index, form) {
            setConfigToCapAddress(form);
            deleteAutoCompleteBrowser(form);
            handleMultipleCountryInForm(form);
        });
    }
};
